/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {RoutingModule} from "@intuitionrobotics/thunderstorm/frontend";
import {AdminTab} from "./pages/ui/patientsTable/AdminTab";
import {Page_Messages} from "./pages/ui/messages/Page_Messages";
import {Page_Dashboard} from "./pages/Page_Dashboard";
import {Page_CarePlan} from "./pages/Page_CarePlan";
import {PatientTab} from "./pages/ui/patients/PatientTab";
import {PatientsHome} from "./pages/home/PatientsHome";
import {AlertsTab} from "./pages/home/AlertsTab";
import {AdminUserTab} from "./pages/ui/patientsTable/UserAdminTab";
import {PatientsAdminTab} from "./pages/ui/patientsTable/PatientsAdminTab";
import {OrganizationsAdminTab} from "./pages/ui/patientsTable/OrganizationsAdminTab";
import {AppHome} from "./AppHome";
import {Page_WellnessCoach} from "./pages/Page_WellnessCoach";
import {Page_Hedis} from "./pages/Page_Hedis";
import {Page_CheckIn} from "./pages/Page_CheckIn";
import {Page_Unsubscribe} from "./pages/Page_Unsubscribe";
import {Loader} from "../widgets/Loader";
import {TabPermissions} from "@app/app-shared/permission";
import {AdminPermissionTab} from "./pages/ui/patientsTable/PermissionAdminTab";
import {extractTabPermissions, getUserTokenInfo, isAdmin} from "@modules/utils";
import {config} from "../config";

export const Route_Base = "base";
export const Route_Messages = "messages";
export const Route_Admin = "admin";
export const Route_AdminUser = "admin_users";
export const Route_AdminPermission = "admin_permissions";
export const Route_AdminOrganizations = "admin_organizations";
export const Route_AdminPatients = "admin_patients";
export const Route_Alerts = "alerts";
export const Route_CarePlan = "care-plan";
export const Route_Dashboard = "dashboard";
export const Route_Hedis = "hedis";
export const Route_CheckIn = "check-in";
export const Route_WellnessCoach = "wellness-coach";
export const Route_PatientsHome = "customers";
export const Route_Patients = "patients-main";
export const Route_Unsubscribe = "unsubscibe";
export const Route_Commands = "commands";
export const Route_ExternalCommands = "external-commands";
export const CommandsPath = "/commands";
export const ExternalCommandsPath = "/ec";
export const Route_Default = "default";
export const Route_Loader = "loader";
export const PARAM_CHAT_ID = "chatId";
export const PARAM_CONTACT_ID = "contactId";

export const registerRoutes = () => {
    const userTokenInfo = getUserTokenInfo();
    const tabPermission = extractTabPermissions(userTokenInfo);

    RoutingModule.clearRoutes();

    // 2nd level routes (Inside of MyApp)
    // RoutingModule.addRoute(Route_AllPatients, "/all-patients", AllPatientsTab);
    // RoutingModule.addRoute(Route_Transient, "/transient", TransientTab);
    if (tabPermission === TabPermissions.MESSAGES || tabPermission === TabPermissions.CLINICAL_MESSAGES)
        RoutingModule.addRoute(Route_Messages, "/messages", Page_Messages);

    const hasClinicalPermissions = tabPermission === TabPermissions.CLINICAL || tabPermission === TabPermissions.CLINICAL_MESSAGES;
    if (hasClinicalPermissions) {
        RoutingModule.addRoute(Route_Alerts, "/alerts", AlertsTab);
        RoutingModule.addRoute(Route_CheckIn, "/check-in", Page_CheckIn);
        RoutingModule.addRoute(Route_Base, "/", AlertsTab).setExact(false);
    } else {
        RoutingModule.addRoute(Route_Base, "/", Page_Messages).setExact(false);
    }

    if (isAdmin(userTokenInfo)) {
        RoutingModule.addRoute(Route_AdminPatients, "/admin/customers", PatientsAdminTab);
        RoutingModule.addRoute(Route_AdminUser, "/admin/user", AdminUserTab);
        RoutingModule.addRoute(Route_AdminPermission, "/admin/permission", AdminPermissionTab);
        RoutingModule.addRoute(Route_AdminOrganizations, "/admin/organizations", OrganizationsAdminTab);
        RoutingModule.addRoute(Route_Admin, "/admin", AdminTab);
    }

    if (hasClinicalPermissions) {
        RoutingModule.addRoute(Route_CarePlan, "/customer/care-plan", Page_CarePlan);
        RoutingModule.addRoute(Route_Dashboard, "/customer/dashboard", Page_Dashboard);
        RoutingModule.addRoute(Route_Hedis, "/customer/hedis", Page_Hedis);
        RoutingModule.addRoute(Route_WellnessCoach, "/customer/wellness-coach", Page_WellnessCoach);
        // If we have a patientId, we should go to the patient tab
        RoutingModule.addRoute(Route_Patients, "/customer", PatientTab).setExact(false);
    }

    // If we don't have a patientId, we should go to the patient home page (list)
    RoutingModule.addRoute(Route_PatientsHome, "/customer", PatientsHome).setExact(true);
    RoutingModule.addRoute(Route_Unsubscribe, "/unsubscribe", Page_Unsubscribe).setExact(false);
    RoutingModule.addRoute(Route_Commands, CommandsPath, () => window.location.href = config.commandsUrl + window.location.search);
    RoutingModule.addRoute(Route_ExternalCommands, ExternalCommandsPath, () => window.location.href = config.commandsUrl + "/ec" + window.location.search);

    RoutingModule.addRoute(Route_Default, "/", AppHome).setExact(false);
};

export function registerValidatingRoutes() {
    RoutingModule.clearRoutes();
    RoutingModule.addRoute(Route_Unsubscribe, "/unsubscribe", Page_Unsubscribe).setExact(false);
    RoutingModule.addRoute(Route_Loader, "/", Loader).setExact(false);
}
